import React from 'react';

export default function AfterVideo({ isShowing, text }) {
  return (
    <div className={`after-video ${isShowing ? 'active' : ''}`}>
      <h2>{text}</h2>
    </div>
  );
}
